import { useQuery } from "react-query";
import {
  CustomModal,
  Pagination,
  TableHeader,
  TableLoading,
  UserInformation,
} from "../../../../../../components";
import Context from "../../../../../../context";
import values from "../../../../../../values";
import api from "../../../../../../api";
import React, { useState } from "react";
import utils from "../../../../../../utils";
import {
  DEBT_USER_TYPE,
  INVOICES_STATUS,
  PAY_TYPE,
  RECEIVER_TYPE,
  TRANSACTION_STATUS,
} from "../../../../../../values/dropdownItems";
import "./index.scss";
import GetUserInfo from "../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

const Invoice = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedDebt } = React.useContext(
    Context.DebtsScreen
  );
  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! ----------------------------------------------------------------------------------------------------------

  const invoices = selectedDebt?.factorsList;

  const factorList = useQuery(
    [values.useQueryKeys.adminDebtFactor, selectedDebt?._id],
    () =>
      api.get.administrator.getAllAdminDebtFactors({
        debtId: selectedDebt?._id,
      }),
    { enabled: selectedDebt?._id !== undefined }
  );

  let info: { name: string; value: string; id?: string }[] = [];

  info = GetUserInfo(selectedDebt);

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  const { t } = useTranslation();

  return (
    <CustomModal
      onClose={() => {
        setShowModal!("NONE");
        // setFormData({});
        // setStep(1);
      }}
      open={showModal === "SHOW_FACTORS"}
      minWidth={"40vw"}
    >
      <div className="justify-center">
        <h6>{t("factors")} </h6>
        <div id="user-information-debt-factor">
          {factorList?.status === "success" && (
            <UserInformation
              name={info?.find((item) => item?.id === "name")?.value}
              phoneNumber={
                info?.find((item) => item?.id === "lastName")?.value +
                " ( " +
                DEBT_USER_TYPE?.find((item) => item?._id === selectedDebt?.type)
                  ?.name +
                " )"
              }
            />
          )}
        </div>

        {factorList?.status === "loading" ? (
          <table className="justify-center">
            <TableLoading />
          </table>
        ) : (
          <table>
            <TableHeader
              headers={values.tableHeaders.INVOICE_HEADERS.map((item) =>
                t(item)
              )}
            />
            <tbody>
              {factorList?.data?.result?.map((invoice: any, index: number) => {
                return (
                  <>
                    {
                      <tr key={`parent-${index}`}>
                        <td
                          className="pointer"
                          // onClick={() => onClick(parent)}
                        >
                          {index + 1}
                        </td>
                        {/* actions */}
                        <td>
                          {utils.convertNumberToPrice(invoice?.amount)}{" "}
                          {t("toman")}
                        </td>
                        <td>
                          {
                            TRANSACTION_STATUS?.find(
                              (item) => item.value === invoice?.status
                            )?.name
                          }
                        </td>
                        <td>
                          {utils.convertGregorianToJalali({
                            date: invoice?.newSubscriptionDate,
                            format: "jYYYY/jMM/jDD",
                          })}
                        </td>
                        <td>
                          {utils.convertGregorianToJalali({
                            date: invoice?.oldSubscriptionDate,
                            format: "jYYYY/jMM/jDD",
                          })}
                        </td>

                        {/* <td>
                          <div className="table-actions-buttons">
                            <CustomIcon
                              icon="fa fa-credit-card"
                              hoverTitle="پرداخت"
                              
                            />
    
                          </div>
                        </td> */}
                      </tr>
                    }
                  </>
                );
              })}
            </tbody>
          </table>
        )}
        {/* {status === "success" && data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) => setPage(page)}
            />
          </div>
        )} */}
      </div>
    </CustomModal>
  );
};

export default Invoice;
